"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCandyMachineAccountDataSerializer = void 0;
const mpl_token_metadata_1 = require("@metaplex-foundation/mpl-token-metadata");
const serializers_1 = require("@metaplex-foundation/umi/serializers");
const _1 = require(".");
function getCandyMachineAccountDataSerializer() {
    return (0, serializers_1.mapSerializer)((0, serializers_1.struct)([
        ['discriminator', (0, serializers_1.array)((0, serializers_1.u8)(), { size: 8 })],
        ['version', (0, _1.getAccountVersionSerializer)()],
        ['tokenStandard', (0, mpl_token_metadata_1.getTokenStandardSerializer)()],
        ['features', (0, serializers_1.array)((0, serializers_1.u8)(), { size: 6 })],
        ['authority', (0, serializers_1.publicKey)()],
        ['mintAuthority', (0, serializers_1.publicKey)()],
        ['collectionMint', (0, serializers_1.publicKey)()],
        ['itemsRedeemed', (0, serializers_1.u64)()],
        ['data', (0, _1.getCandyMachineDataSerializer)()],
    ], { description: 'CandyMachineAccountData' }), (value) => ({
        ...value,
        discriminator: [51, 173, 177, 113, 25, 241, 109, 189],
    }));
}
exports.getCandyMachineAccountDataSerializer = getCandyMachineAccountDataSerializer;
//# sourceMappingURL=candyMachineAccountData.js.map